<ion-select
  [label]="getLabel()"
  label-placement="floating"
  fill="outline"
  (ionChange)="selectedUserChanged.emit($event.detail.value)"
  mode="md"
  [multiple]="multiple"
  interface="popover"
  [value]="getPreselectedUser() | async"
  [disabled]="disabled"
>
  <ion-select-option [value]="null" *ngIf="showAllEntry"
    >Alle Mitarbeiter</ion-select-option
  >
  <ion-select-option
    *ngFor="let user of this.filteredUsers | async"
    [value]="user.userName"
    >{{ user.firstName }} {{ user.lastName }}</ion-select-option
  >
</ion-select>
